import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PAYMENT_TERM } from "./apiRoutes";

const getPaymentTerms = async () => await axiosAuth.get(`${PAYMENT_TERM}`);

const useGetPaymentTerms = (
  queryParams?: Omit<UseQueryOptions, "queryKey">
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["payment-Term"],
    queryFn: () => getPaymentTerms(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPaymentTerms;
